import { Claim } from '@dav-model/api/response/claims.response';
import { HistoryFilter } from '@dav-model/history-filter';
import { Action } from '@ngrx/store';

/**
 * When User initially visits our page, UI will
 * get all images and css
 */

export const GET_CLAIMS = '[Claims] GET CLAIMS';
export const GET_CLAIMS_SUCCESS = '[Claims] GET CLAIMS SUCCESS';
export const FILTER_GRID = '[Claims] FILTER GRID';

export const CLAIMS_FAILURE = '[Claims] CLAIMS FAILURE';

export class GetClaimsAction implements Action {
  readonly type = GET_CLAIMS;

  constructor(public payload: { vin: string, claimNumber: string } = { vin: '', claimNumber: '' }) {
  }
}

export class GetClaimsSuccessAction implements Action {
  readonly type = GET_CLAIMS_SUCCESS;

  constructor(public payload: { claims: Claim[], filters: HistoryFilter }) {
  }
}

export class FilterGridAction implements Action {
  readonly type = FILTER_GRID;

  constructor(public payload: HistoryFilter) {
  }
}

export class ClaimsFailureAction implements Action {
  readonly type = CLAIMS_FAILURE;
}

export type All = GetClaimsAction | GetClaimsSuccessAction | FilterGridAction | ClaimsFailureAction;
